import  React from 'react'
import { Alert } from 'react-bootstrap'
import {
  BooleanRadioButtonField, yesNoDataSource, IField, validateFieldsEx,
} from '../../../../shared/fields'
import { ApplicationModel } from '../../../../models/ApplicationModel'
import { RepresentativeCategories } from '../../../../shared/Utility'
import EMDGAccordion from '../../../../shared/EMDGAccordion'
import { GRANT_GUIDELINES_URL } from '../..'

export interface Props {
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    visible: boolean
    preview?: boolean
}

export interface State {

}

export default class TourismServicesContainer extends React.Component<Props, State> implements IField {
    areTourismServicesSuppliedToForeignPersons: BooleanRadioButtonField
    tourismExcludedServices: BooleanRadioButtonField
    tourismServiceSatisfyRequirement: BooleanRadioButtonField

    constructor(props: Props) {
      super(props)

      this.state = {

      }
    }

    componentDidUpdate(prevProps: Props) {
      const { model, onChange, visible } = this.props

      if (visible
        && (model.areTourismServicesSuppliedToForeignPersons !== prevProps.model.areTourismServicesSuppliedToForeignPersons)) {
        onChange({ tourismExcludedServices: null, tourismServiceSatisfyRequirement: null })
      }
      if (model.tourismServiceSatisfyRequirement !== prevProps.model.tourismServiceSatisfyRequirement) {
        onChange({ tourismExcludedServices: null })
      }
    }

    validate(callback: { (res: boolean): any }, focus?: boolean) {
      const { model } = this.props
      if (model.areTourismServicesSuppliedToForeignPersons === false || model.tourismServiceSatisfyRequirement === false || model.tourismExcludedServices) {
        callback && callback(false); // don't ever continue!
        return;
      }
      validateFieldsEx(focus, callback,
        this.areTourismServicesSuppliedToForeignPersons,
        this.tourismServiceSatisfyRequirement,
        this.tourismExcludedServices,
      )
    }

    render() {
      const {
        model, onChange, visible, preview,
      } = this.props
      return (
        visible && (
          <div style={{ marginTop: '30px' }}>
            { preview && <h4>Tourism services</h4>}
            <EMDGAccordion expanded header="Tourism services">
              <BooleanRadioButtonField
                ref={(r) => { this.areTourismServicesSuppliedToForeignPersons = r }}
                id="areTourismServicesSuppliedToForeignPersons"
                label="73. Is the tourism service supplied in Australia to foreign persons (excluding New Zealanders)?"
                value={model.areTourismServicesSuppliedToForeignPersons}
                onChange={(areTourismServicesSuppliedToForeignPersons) => onChange({ areTourismServicesSuppliedToForeignPersons })}
                required={visible}
                description={(
                  <i>
                    For a tourism service to be eligible, it must be of substantially Australian origin and supplied in Australia to foreign persons.
                  </i>
              )}
                dataSource={yesNoDataSource}
                preview={preview}
              />
              {!model.areTourismServicesSuppliedToForeignPersons && model.areTourismServicesSuppliedToForeignPersons !== null && (
                <Alert className="emdg-page-alerts emdg-page-alerts--error ">
                    You are <b>not</b> eligible to apply for a grant as you do not have an eligible tourism service.
                </Alert>
              )}

              {model.areTourismServicesSuppliedToForeignPersons && (
                <>
                  <BooleanRadioButtonField
                    ref={(r) => { this.tourismServiceSatisfyRequirement = r }}
                    id="tourismServiceSatisfyRequirement"
                    label="73.a Does the tourism service you supply meet at least one of the following conditions? "
                    description={(
                      <ul>
                          <li style={{ marginTop: '0px' }}>passenger transport by land, including vehicle hire (but not a transfer service for foreign tourists)</li>
                          <li>passenger transport by water or air</li>
                          <li>overnight accommodation unless for a business purpose or study</li>
                          <li>tours</li>
                          <li>paid admission to:
                            <ul>
                                <li style={{ marginTop: '0px' }}>a place that has one or more outstanding natural features or is of historical interest</li>
                                <li style={{ marginTop: '0px' }}>a park, nature reserve or botanical garden</li>
                                <li style={{ marginTop: '0px' }}>a wildlife sanctuary or zoological garden</li>
                                <li style={{ marginTop: '0px' }}>a museum, art gallery or craft centre</li>
                                <li style={{ marginTop: '0px' }}>a place that is, or provides, an amenity appropriate to tourists</li>
                                <li style={{ marginTop: '0px' }}>an event.</li>
                            </ul>
                          </li>
                          <li>services at a place the main purpose of which is to provide a venue and associated facilities for meetings, conventions and exhibitions</li>
                          <li>the services of a restaurant or cafe</li>
                          <li>services directly related to the act of gambling in a licensed casino.</li>
                      </ul>
                    )}
                    value={model.tourismServiceSatisfyRequirement}
                    onChange={(tourismServiceSatisfyRequirement) => onChange({ tourismServiceSatisfyRequirement })}
                    required={visible && model.areTourismServicesSuppliedToForeignPersons}
                    dataSource={yesNoDataSource}
                    preview={preview}
                  />
                  {!model.tourismServiceSatisfyRequirement && model.tourismServiceSatisfyRequirement !== null && (
                        <Alert className="emdg-page-alerts emdg-page-alerts--error ">
                            You are <b>not</b> eligible to apply for a grant as you do not have an eligible tourism service.
                        </Alert>
                  )}
                  {model.tourismServiceSatisfyRequirement && (
                    <>
                        <Alert className="emdg-page-alerts">
                           You have an eligible tourism service. Proceed to Question 74
                        </Alert>

                  <BooleanRadioButtonField
                    ref={(r) => { this.tourismExcludedServices = r }}
                    id="tourismExcludedServices"
                          label="74. Does the service that you export relate to any one of the following? "
                    description={(
                      <ul>
                                <li style={{ marginTop: '0px' }}>migration to Australia, including proceedings or actions to enter or remain in Australia</li>
                                <li>adoption, custody or welfare of a child</li>
                                <li>proceedings about the maintenance of a person</li>
                                <li>proceedings under the Family Law Act 1975</li>
                                <li>identification, procurement, lease, sale or purchase of assets in Australia (whether tangible or intangible), including cash, real estate, stocks, options or shares</li>
                                <li>protection, operation or maintenance of assets held in Australia</li>
                                <li>compliance with the laws of Australia</li>
                                <li>prostitution</li>
                                <li>pornographic material, including pornographic material in publications, films or computer games, or accessible on the internet</li>
                                <li>activities or products that are unlawful</li>
                                <li>the provision of a gambling service by a person not licensed under an Australian law to provide the service</li>
                                <li>any service supplied in Australia to foreign tourists that is not a tourism service</li>
                                <li>selection or recruitment of students to work in Australia.</li>
                      </ul>
              )}
                    value={model.tourismExcludedServices}
                    onChange={(tourismExcludedServices) => onChange({ tourismExcludedServices })}
                          required={visible && model.tourismServiceSatisfyRequirement}
                    dataSource={yesNoDataSource}
                    preview={preview}
                  />
                    </>
                  )}
                  { model.tourismExcludedServices ? (
                    <Alert className="emdg-page-alerts emdg-page-alerts--error ">
                      These services are excluded. Unless you have another eligible service, you are <b>not</b> eligible to apply for a grant. 
                      If you have a combination of services, you must exclude expenses related to marketing the excluded services from your grant application.
                    </Alert>
                  ) : null}
                  {!model.tourismExcludedServices && model.tourismExcludedServices !== null && (
                    <Alert className="emdg-page-alerts">
                        You declare that you export services that are not excluded as per Section 5.2.2.3 of the
                        {' '}
                        <a target="_blank" href={`${GRANT_GUIDELINES_URL}`} rel="noreferrer">
                            Grant Guidelines
                        </a>
                        .
                </Alert>
              )}
                  </>
)}
            </EMDGAccordion>
          </div>
        )
      )
    }
}
